import React from "react"

import "./Footer.sass"

const Footer = () => (
  <footer className="Footer">
    <span className="copyright">
      <a href="https://amzs.si">
        <span className="year">&copy; {new Date().getFullYear()}</span> AMZS
      </a>
    </span>

    <span className="meta">
      <a href="/legal/">Pravno obvestilo</a>
      <a href="/faq/">O storitvi</a>
    </span>

    <span className="services">
      {/* <a href="/saved">Shranjeno</a> */}
      <a href="/moja-garaza/">Moja garaža</a>
      <a href="/rabljenavozila/">Rabljena vozila</a>
    </span>

    <span className="contact">
      <a href="mailto:info@avtolog.si">info@avtolog.si</a>
    </span>
  </footer>
)

export default Footer
